import type { ReactNode } from 'react'

import { Pantalla } from '@/componentes/ui/Pantalla'
import { PANTALLAS } from '@/lib/menu'
import { useModulos } from '@/lib/modulos'

/**
 * Deja pasar solo si el local usa el módulo de esa pantalla.
 *
 * Con el módulo apagado el ítem no está en el menú, así que a esta ruta se
 * llega por un favorito o por un enlace viejo —o después de apagarlo con la
 * pantalla abierta—. Sin esto, lo que se vería es la pantalla cargando y
 * después el error de sus endpoints, que contestan 404: un mensaje de sistema
 * roto para algo que el local decidió.
 *
 * El módulo y el nombre salen del catálogo de pantallas y no de una lista
 * propia: una segunda tabla de correspondencias es la que queda vieja el día
 * que se agrega un módulo.
 */
export function SoloConModulo({ pantalla, children }: { pantalla: string; children: ReactNode }) {
  const { activo } = useModulos()
  const catalogo = PANTALLAS[pantalla]

  if (catalogo?.modulo && !activo(catalogo.modulo)) {
    return <Pantalla.ModuloApagado nombre={catalogo.titulo.toLowerCase()} />
  }

  return <>{children}</>
}
